var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("Home")])]),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"})]),_c('footer',{staticClass:"card-footer"})])])
}]

export { render, staticRenderFns }